import styled from 'astroturf/react'
import { useSelector } from 'react-redux'

import { useI18n } from 'locales'
import { isPollSelector } from 'selectors/event_type'
import { isNoTouchDevice } from 'services/touch_device_detection'

import { InviteeCountDisplay, InviteeCounter, ThumbsUpIcon } from '../../styles'
import { useInviteeVoteTooltip } from '../../invitee_vote_tooltip'
import { sortInvitees } from '../../utils'

import OutlinedThumbsUp from './icons/thumbs-up-default.svg'
import SolidThumbsUp from './icons/thumbs-up-filled.svg'
import _Container from "invitee_count-Container.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/select_date_time/flat_spotpicker/invitee_count_time_button/invitee_count.js?styleId=Container";


const Container = /*#__PURE__*/styled('div', null, {
  displayName: "Container",
  styles: _Container,
  attrs: props => ({
    ...props,
    isNoTouchDevice: isNoTouchDevice()
  })
})

export const InviteeCount = ({ spot, focused, selected }) => {
  const { i18n } = useI18n()
  const isPoll = useSelector(isPollSelector)
  const invitees = sortInvitees([...(spot.invitees || [])])
  const [InviteeVoteTooltip, tooltipHostProps] = useInviteeVoteTooltip({ invitees })

  if (!isPoll) return null

  const inviteesCount = invitees.length

  if (selected) invitees.unshift({ full_name: i18n.t('publisher.title.you') })

  const hasInvitees = invitees.length > 0

  const iconSrc = selected ? SolidThumbsUp : OutlinedThumbsUp

  const hasDoubleDigitInvitees = invitees.length >= 10

  return (
    <Container
      hasInvitees={hasInvitees}
      hasDoubleDigitInvitees={hasDoubleDigitInvitees}
      focused={focused}
      selected={selected}
      {...tooltipHostProps}
    >
      <ThumbsUpIcon
        src={iconSrc}
        selected={selected}
        hasInvitees={hasInvitees}
      />
      <InviteeCountDisplay>
        <InviteeCounter roll={selected} visible={!selected}>{inviteesCount > 0 ? inviteesCount : <>&nbsp;</>}</InviteeCounter>
        <InviteeCounter roll={selected} visible={selected}>{inviteesCount + 1}</InviteeCounter>
      </InviteeCountDisplay>
      <InviteeVoteTooltip />
    </Container>
  )
}
